import React from "react";

import { TStatisticsBettingData } from "@data-types/offer/event-betting-type/StatisticsBettingData";
import { BettingData } from "@data-types/sport-stats/SportStatsTypes";
import TipButton from "@features/offer/mobile/shared/common/offer-grid/tip-button/TipButton";
import { PlayerStatistics } from "@features/offer/shared/statistics/components/player-betting-types";
import { EventKeyBettingOffer, Player } from "@gp/models";
import { ObservableMap } from "mobx";
import { observer } from "mobx-react";

export const PlayerTipButton = observer(function PlayerTipButton({
	players,
	tip,
	toggleState,
	bettingTypeAbrv,
	isStats,
}: {
	players: ObservableMap<string, Player>;
	tip: EventKeyBettingOffer;
	toggleState?: TStatisticsBettingData | null;
	bettingTypeAbrv: string;
	isStats?: boolean;
}) {
	let playerName: string;
	const player = players.get(tip.playerId || "");

	if (player) {
		playerName = `${player.firstName}-${player.lastName}`;
	}

	const tipData = toggleState?.data?.find(
		(item) => item.playerAbrv == playerName.toLowerCase()
	)?.data as BettingData;

	return (
		<>
			<TipButton
				key={tip.id}
				isPlayer
				tipContainerClasses="is-long"
				tip={tip}
				hasPlaceHolders={false}
				isStats={isStats}
			/>
			{toggleState?.action === "stats" && tipData ? (
				<PlayerStatistics
					bettingTypeAbrv={bettingTypeAbrv}
					bettingTypeStats={tipData}
				/>
			) : null}
		</>
	);
});
